const config = {
  onboarding: [
    {
      hint: {
        title: "This is a node",
        description: "It's like a stickie note. Try typing in your favorite animal",
        img_url: "https://dopniceu5am9m.cloudfront.net/static/imagica.ai/tutorial/guide_step_0.svg",
        is_show_next: true,
        arrowPointing: "right",
      },
      step: 1,
      nodes: [],
      edges: [],
    },
    {
      hint: {
        title: "Create your AI function",
        description: "Click on the “+” button to create an AI that does something to your node.",
        img_url: "https://dopniceu5am9m.cloudfront.net/static/imagica.ai/tutorial/guide_step_1.svg",
        is_show_next: false,
      },
      step: 2,
      nodes: [],
      edges: [],
    },
    {
      hint: {
        title: "Describe your AI function",
        description: `You can create an AI by describing it. Try "generate a storyboard from an idea" and press Enter to continue.`,
        img_url: "https://dopniceu5am9m.cloudfront.net/static/imagica.ai/tutorial/guide_step_2.svg",
        is_show_next: false,
      },
      step: 3,
      nodes: [
        {
          id: "editor-0",
          data: {
            // 新增
            isShowRightAddIcon: false,
            // availableEl: []
          },
        },
        {
          id: "editor-1",
          type: "customNode",
          data: {
            textAreaValue: "",
            displayType: "text",
          },
        },
      ],
      edges: [
        {
          id: "edge-0",
          type: "customEdge",
          animated: true,
          source: "editor-0",
          target: "editor-1",
          data: {
            isGetQuery: false,
            guideDisableAiDescriptionInput: true,
            notAutoBlur: true,
            guideAiDescriptionList: [
              "generate a storyboard from an idea",
              "generate a creative script from an idea",
              "transform an idea into a storyboard",
              "develop a storyboard based on an initial concept",
            ],
          },
        },
      ],
    },
    {
      hint: {
        title: "Great!",
        description: "Now you have a new AI function that will {stepEdgeText}.",
        img_url: "https://dopniceu5am9m.cloudfront.net/static/imagica.ai/tutorial/guide_step_3.svg",
        is_show_next: true,
      },
      step: 4,
      nodes: [],
      edges: [],
    },
    {
      hint: {
        title: "Split Output",
        description: "Let’s split the text into separate nodes so we can create images for each scene.",
        img_url: "https://dopniceu5am9m.cloudfront.net/static/imagica.ai/tutorial/guide_step_4.png",
        is_show_next: false,
      },
      step: 5,
      nodes: [],
      edges: [],
    },
    {
      hint: {
        title: "Image Generation",
        description: "You have split the nodes! Now let's generate images for each one.",
        img_url: "https://dopniceu5am9m.cloudfront.net/static/imagica.ai/tutorial/guide_step_5.svg",
        is_show_next: false,
      },
      step: 6,
      nodes: [],
      edges: [],
    },
    {
      hint: {
        title: "Generate images",
        description: ["Type ", "/", " to select an image generation style."],
        img_url: "https://dopniceu5am9m.cloudfront.net/static/imagica.ai/tutorial/guide_step_6.png",
        is_show_next: false,
        arrowPointing: "bottom",
      },
      step: 7,
      nodes: [],
      edges: [],
    },
    {
      hint: {
        title: "Publication",
        description: "Now all that remains is to publish your app.",
        img_url: "https://dopniceu5am9m.cloudfront.net/static/imagica.ai/tutorial/guide_step_8.png",
        is_show_next: false,
        arrowPointing: "top",
        class: "publishStep",
      },
      step: 8,
      nodes: [],
      edges: [],
    },
    {
      hint: {},
      step: 9,
      nodes: [],
      edges: [],
    },
  ],
};

const webApplication = {
  title: "Publish format",
  description: `Click on "Web application" to bring your idea to life.`,
  img_url: "https://dopniceu5am9m.cloudfront.net/static/imagica.ai/tutorial/guide_step_9.png",
  is_show_next: false,
  arrowPointing: "right",
  class: "webApplicationStep",
};

const saasWebsite = {
  title: "Publish format",
  description: `Click on "Saas Website" to bring your idea to life.`,
  img_url: "https://dopniceu5am9m.cloudfront.net/static/imagica.ai/tutorial/guide_step_9.png",
  is_show_next: false,
  arrowPointing: "right",
  class: "webSiteStep",
};

export { webApplication, saasWebsite };

export default config;
